import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { useColorTheme } from '@hooks';
import { generateCustomInputNodeHandle, NODE_HANDLE_IDS } from '@containers/flow/nodes';

const DEFAULT_HANDLE_STYLE = {
  top: '15px',
  left: '6px',
};
export default React.memo(({ data, isConnectable }) => {
  const colorTheme = useColorTheme();
  const id = NODE_HANDLE_IDS.outputAggregation;
  const { name, colorThemeName } = generateCustomInputNodeHandle(id);

  return (
    <Handle
      type="target"
      id={id}
      position={Position.Left}
      style={{ ...DEFAULT_HANDLE_STYLE, background: colorTheme[colorThemeName] }}
      isConnectable={isConnectable}
    />
  );
});
